import { ComponentType } from "react";

/**
 * Returns an instance of the specified component with sub components attached to it, and does not modifiy the original component.
 * @param subComponents The sub components to attach to the component.
 * @param component The component to augment with sub components.
 * @returns The component with sub components attached.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function withSubComponents<T extends ComponentType<any>, TSub extends object>(subComponents: TSub, component: T): T & TSub {
  /* We use <any> here because it just makes our life a lot easier since we really don't know the concrete types
     we're using and just straight pass things through anyway. */

  for (const key of Object.keys(subComponents)) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (component as any)[key] = subComponents[key as keyof TSub];
  }

  return component as T & TSub;
}
